var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyChatLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 140,
    viewBox: "0 0 246 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8655_88685)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 24.5,
    width: 160,
    height: 52,
    rx: 12,
    fill: "#F9FBFF",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 40.5,
    width: 28,
    height: 20,
    rx: 4,
    fill: "#F0F3FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 43.5,
    width: 92,
    height: 5,
    rx: 2.33723,
    fill: "#F0F3FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 52.5,
    width: 40,
    height: 5,
    rx: 2.33723,
    fill: "#F0F3FA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_8655_88685)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 51.5,
    width: 160,
    height: 52,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 67.5,
    width: 28,
    height: 20,
    rx: 4,
    fill: "#F0F3FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 70.5,
    width: 92,
    height: 5,
    rx: 2.33723,
    fill: "#DFE5F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 79.5,
    width: 40,
    height: 5,
    rx: 2.33723,
    fill: "#F0F3FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8655_88685",
    x: 26,
    y: 0.5,
    width: 220,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8655_88685"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8655_88685",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_8655_88685",
    x: 0,
    y: 27.5,
    width: 220,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8655_88685"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8655_88685",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChatLight);
export default __webpack_public_path__ + "static/media/empty-chat-light.23c1785b99f36d6f4e385a8ca57450b6.svg";
export { ForwardRef as ReactComponent };